import { SUPPORTED_UNITS } from '@schuettflix/interfaces';

export type CommittedProductFormRule<TUnit extends SUPPORTED_UNITS = SUPPORTED_UNITS> = {
    salesQuantity: {
        minValue: number;
        unit: TUnit;
    };
    disableDelete: boolean;
    disableSalesUnit: boolean;
};

export function getCommittedProductsFormRules<
    T extends {
        id: string;
        salesQuantity: number;
        fulfilledQuantity: number;
        reservedQuantity: number;
        salesUnit: SUPPORTED_UNITS;
    },
    R = CommittedProductFormRule<T['salesUnit']>,
>(
    products: T[],
    mapRule: (rule: CommittedProductFormRule<T['salesUnit']>) => R = rule => rule as R
): Record<string, R> {
    return products.reduce<Record<string, R>>((rules, product) => {
        const orderedQuantity = product.fulfilledQuantity + product.reservedQuantity;

        rules[product.id] = mapRule({
            salesQuantity: {
                minValue: Math.min(orderedQuantity, product.salesQuantity),
                unit: product.salesUnit,
            },
            disableDelete: orderedQuantity > 0,
            disableSalesUnit: orderedQuantity > 0,
        });

        return rules;
    }, {});
}
